import * as React from "react";
import {
  Typography,
  Box,
  Button,
  Grid,
  MenuItem,
} from "@mui/material";
import { connect } from "react-redux";
import {
  Navigate,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  MainInput,
  centered_flex_box,
  left_flex_box,
  main_button,
} from "../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Image, notification, Space, Table, Tag } from "antd";
import Logo from "../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import ImageComponent from "../app/components/ImageComponent";
import { updateOrderFulfillment, getOrders, getProducts } from "../app/store/actions/dataActions";
import { refreshPassword } from "../app/store/actions/authActions";
import { useEffect } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import moment from "moment";
import { useState } from "react";
import cities from "../constants/cities.json";
import { FincartAreaField } from "../app/components/FincartAreaField";
import { PasswordVerificationModal } from "../app/components";
import { useTranslation } from "react-i18next";

const hasValidPhone = (phone) => /^\+201\d{9}$/.test(String(phone ?? "").replace(/\s+/g, ""));

export const EditOrderFulfillment = ({
  user,
  order,
  getOrders,
  updateOrderFulfillment,
  refreshPassword,
  isLoading
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    getOrders({ orderId: id }, navigate)
  }, [id])

  const [formData, setFormData] = useState({
    customer: {
      first_name: "",
      last_name: "",
    },
    phone: "",
    shipping_address: {
      address1: "",
      address2: "",
      province: "Cairo",
      area: "",
    },
    current_total_price: 0,
    orderId: id
  });

  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  useEffect(() => {
    if(order && order.orderFulfillment) {
      setFormData({
        ...formData,
        customer: {
          first_name: order.orderFulfillment.shippingAddress.first_name || order.orderFulfillment.customer.split(" ")[0],
          last_name: order.orderFulfillment.shippingAddress.last_name || order.orderFulfillment.customer.split(" ")[1],
        },
        phone: order.orderFulfillment.phone,
        shipping_address: {
          address1: order.orderFulfillment.shippingAddress.address1,
          address2: order.orderFulfillment.shippingAddress.address2,
          province: order.orderFulfillment.shippingAddress.province,
          area: order.orderFulfillment.shippingAddress.area || "",
        },
        current_total_price: order.orderFulfillment.price
      })
    }
  }, [order])

  const canSubmit = () => {
    return (
      formData.customer.first_name &&
      formData.customer.last_name &&
      hasValidPhone(formData.phone) &&
      formData.shipping_address.address1 &&
      formData.shipping_address.province &&
      formData.current_total_price
    );
  };

  const handleSubmit = () => {
    if(!canSubmit()) {
      notification.error({
        message: hasValidPhone(formData.phone)
          ? t("fulfillment.errors.requiredFields")
          : t("fulfillment.errors.phoneFormat"),
      });
      return;
    }
    setPasswordModalOpen(true);
  }

  const handlePasswordVerify = async (password) => {
    try {
      const result = await refreshPassword(password);
      if (result.type === "WAIT_SUCCESS") {
        setPasswordModalOpen(false);
        updateOrderFulfillment(formData, navigate);
      } else {
        // Error is already handled in the action
      }
    } catch (error) {
      notification.error({ message: t("fulfillment.errors.passwordVerificationFailed") });
    }
  };

  const handlePasswordModalClose = () => {
    setPasswordModalOpen(false);
  };

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor4)" }}>{t("fulfillment.editTitle", { orderNumber: order?.shopifyOrderNumber || "" })}</Typography>
          {/* <IconButton onClick={() => navigate("/ims/admin/products/add")} sx={{ color: "var(--secColor)", mx: 2 }}><AddCircleOutline /></IconButton> */}
        </Box>
        <Box sx={{}}>
          <Box sx={{ ...left_flex_box }}>
            <Grid container sx={{}}>
              <Grid item xs={12}>
                <Typography variant='h6'>{t("fulfillment.customerInformation")}</Typography>
                <Grid item container spacing={2} xs={12}>
                  <Grid item xs={4}>
                    <MainInput
                      margin="normal"
                      label={t("fulfillment.firstName")}
                      required
                      value={formData.customer.first_name}
                      fullWidth
                      onChange={({ target }) => setFormData({ ...formData, customer: { ...formData.customer, first_name: target.value } })}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MainInput
                      margin="normal"
                      label={t("fulfillment.lastName")}
                      required
                      value={formData.customer.last_name}
                      fullWidth
                      onChange={({ target }) => setFormData({ ...formData, customer: { ...formData.customer, last_name: target.value } })}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MuiPhoneNumber
                      sx={{
                        "& label": {
                          color: "var(--secColor4) !important",
                        },
                        "& label.Mui-focused": {
                          color: "var(--secColor4) !important",
                        },
                        "& .MuiInput-underline:after": {
                          borderBottomColor: "green",
                        },
                        "& .MuiInputBase-input": {
                          outerHeight: 500,
                          color: "var(--secColor4)",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "1px solid var(--secColor4)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "var(--terColor)",
                          },

                          borderRadius: 0,
                        }
                      }}
                      margin="normal"
                      fullWidth
                      required
                      label={t("fulfillment.phoneNumber")}
                      variant='outlined'
                      onlyCountries={['eg']}
                      defaultCountry={'eg'}
                      countryCodeEditable={false}
                      inputProps={{
                        minLength: 13
                      }}
                      disableAreaCodes
                      value={formData.phone || ""}
                      onChange={(value) => setFormData({ ...formData, phone: value || "" })}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h6'>{t("fulfillment.shippingInformation")}</Typography>
                <Grid item container spacing={2} xs={12}>
                  <Grid item xs={5}>
                    <MainInput
                      margin="normal"
                      label={t("orderDetails.addressLine1")}
                      required
                      value={formData.shipping_address.address1}
                      fullWidth
                      onChange={({ target }) => setFormData({ ...formData, shipping_address: { ...formData.shipping_address, address1: target.value } })}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <MainInput
                      margin="normal"
                      label={t("orderDetails.addressLine2")}
                      value={formData.shipping_address.address2}
                      fullWidth
                      onChange={({ target }) => setFormData({ ...formData, shipping_address: { ...formData.shipping_address, address2: target.value } })}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <MainInput
                      margin="normal"
                      label={t("fulfillment.province")}
                      required
                      value={formData.shipping_address.province}
                      fullWidth
                      select
                      onChange={({ target }) => setFormData({ ...formData, shipping_address: { ...formData.shipping_address, province: target.value, area: "" } })}
                    >
                      {cities.map((city) => <MenuItem key={city} value={city}>{city}</MenuItem>)}
                    </MainInput>
                  </Grid>
                  {user?.vendor?.shippingService === "Fincart" && (
                    <Grid item xs={12}>
                      <FincartAreaField
                        shippingService={user?.vendor?.shippingService}
                        city={formData.shipping_address.province}
                        area={formData.shipping_address.area}
                        onChange={({ target }) => setFormData({ ...formData, shipping_address: { ...formData.shipping_address, area: target.value } })}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h6'>{t("orderDetails.orderInformation")}</Typography>
                <Grid item container spacing={2} xs={12}>
                  <Grid item xs={4}>
                    <MainInput
                      margin="normal"
                      type="number"
                      label={t("common.price")}
                      value={formData.current_total_price}
                      fullWidth
                      onChange={({ target }) => setFormData({ ...formData, current_total_price: target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Button sx={{ ...main_button }} onClick={handleSubmit} disabled={!canSubmit() || isLoading}>
                  { isLoading ? t("fulfillment.updating") : t("fulfillment.update") }
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      
      <PasswordVerificationModal
        open={passwordModalOpen}
        onClose={handlePasswordModalClose}
        onVerify={handlePasswordVerify}
        isLoading={isLoading}
        title={t("fulfillment.verifyPasswordTitle")}
        message={t("fulfillment.verifyPasswordMessage")}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  products: state?.records?.products,
  token: state?.auth?.token,
  order: state?.records?.order
});

const mapDispatchToProps = { getOrders, updateOrderFulfillment, refreshPassword };

export default connect(mapStateToProps, mapDispatchToProps)(EditOrderFulfillment);
